<template>
  <div v-if="model.edit">
    <div v-if="!model.edit.$model">
      <div v-html="model.recipientHTML.$model" />

      <button v-if="model.edit" class="btn btn-primary" @click="editRecipient(true)">Edytuj</button>
    </div>

    <div v-else>
      <w-radio-list class="mt-2" :values="recipientTypeValues" :model="model.recipientType" />

      <w-radio-list class="mt-2" :values="recipientIdentifierValues" :model="model.recipientIdentifier" />

      <person class="mt-2" :title="studentTitle" :model="model.student" />

      <person class="mt-2" :title="tendererTitle" :model="model.tenderer" />

      <w-input class="mt-2" :model="model.tenderer.pesel" />

      <w-input class="mt-2" :model="model.tenderer.nip" />

      <w-input class="mt-2" :model="model.tenderer.workplaceName" />

      <address-picker class="mt-2" :model="model.address" />

      <button class="btn btn-primary mt-2" @click="editRecipient(false)">Podgląd</button>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Person from './Person';
import AddressPicker from '../../../formComponents/AddressPicker';

// @vuese
// Formularz adresata
// @group ActionData
export default {
  components: { ...components, AddressPicker, Person },
  props: {
    // schema
    model: { type: Object, required: true }
  },
  data() {
    return {
      recipientTypeValues: [
        { text: 'Rodzic/opiekun', value: 'Rodzic/opiekun' },
        { text: 'Uczeń/Słuchacz', value: 'Uczeń/Słuchacz' },
        { text: 'Osoba fizyczna/Przedsiębiorstwo', value: 'Osoba fizyczna/Przedsiębiorstwo' }
      ],
      recipientIdentifierValues: [
        { text: 'nip', value: 'nip' },
        { text: 'pesel', value: 'pesel' }
      ]
    };
  },
  computed: {
    studentTitle() {
      if (this.model.recipientType.$model !== 'Rodzic/opiekun') {
        return '';
      }
      if (this.model.student.gender.$model === 1) {
        if (this.model.student.applicantType.$model === 1) {
          return 'Uczeń';
        } else {
          return 'Słuchacz';
        }
      } else {
        if (this.model.student.applicantType.$model === 1) {
          return 'Uczennica';
        } else {
          return 'Słuchaczka';
        }
      }
    },

    tendererTitle() {
      if (this.model.recipientType.$model === 'Rodzic/opiekun') {
        if (this.model.student.gender.$model === 1) {
          return 'Reprezentowany przez';
        } else {
          return 'Reprezentowana przez';
        }
      }
      return 'Adresat';
    }
  },
  methods: {
    // Edytuj adresata
    editRecipient(val) {
      this.model.edit.$setData(val);
    }
  }
};
</script>
